
<script>

import BarList from '../components/bar-list'
import BarGrid from '../components/bar-grid'
import CrmOrgForm from './crm-org-form'
import { SysVars } from '../main';
import CrmEmail from './crm-email'
import CrmFiltrosNegocio from './crm-filtros-negocio'

export default {
    data () {
        return {
            metadata: this.$store.getters.getEntities.metadata,
            selectedFiltro: null,
            selectedUsuario: null,
            selectedEquipe: null,
            showCodemail: null,

            novoEmail: false,

            activeTab: 0,

            tabs: [
                { title: 'Recebidos', help: null, icon: 'fa-arrow-down', count: 0 },
                { title: 'Enviados', help: null, icon: 'fa-arrow-right', count: 0 },
            ],
            
            emailList: []

        }
    },

    components: {
        BarList, BarGrid, CrmEmail, CrmFiltrosNegocio
    },

    computed: {
        naoLidosList() {
            if (this.$store.getters.getEmailCrmList.length)
                return this.$store.getters.getEmailCrmList.filter((obj) => {
                        return obj.visualizado === 'N' && obj.inbox === 'S'
                    })
            else
                return []
        },

        recebidosList() {
            if (this.$store.getters.getEmailCrmList.length)
                return this.$store.getters.getEmailCrmList.filter((obj) => {
                        return obj.inbox === 'S'
                    })
            else
                return []
        },

        enviadosList() {
            if (this.$store.getters.getEmailCrmList.length)
                return this.$store.getters.getEmailCrmList.filter((obj) => {
                        return obj.enviado == 'S'
                    })
            else
                return []
        }

    },

    watch: {

    },

    filters: {

    },

    methods: {
        changeTab (idx) {
            this.activeTab = idx
            this.loadData()
        },

        handleChangeUsuario (cod) {
            this.selectedUsuario = cod
            this.loadData()
        },

        async loadData() {
            
            let param = {}
            if (this.selectedFiltro > 0) 
              param.filtro = this.selectedFiltro
            if (this.selectedUsuario > 0) 
              param.codusuario = this.selectedUsuario

            this.showCodemail = null
            await this.$store.dispatch('loadEmailCrm', param )

            if (this.activeTab == 0) {
                this.emailList = this.recebidosList
            } else
            if (this.activeTab == 1) {
                this.emailList = this.enviadosList
            }

            this.tabs[0].count = this.naoLidosList.length

            this.$nextTick(function () {
                jQuery('[data-toggle="tooltip"]').tooltip()
            })
        },

        handleNovoEmail () {
            this.novoEmail = true
        },

        closeEmail (email) {
            if (email) {
                let list = this.emailList.filter((obj) => {
                    return obj.codemail == email.codemail && obj.visualizado == 'N'
                })
                if (list.length > 0) 
                    list[0].visualizado = 'S'
            }
            this.showCodemail = null
        }

    },

    created () {
        this.$store.dispatch('loadConfigCrm', this).then(
            this.loadData()
        )
    }

}

</script>

<template>
    <div>
            <!-- <div class="mt-2">
                <crm-filtros-negocio :email="true" @changeUsuario="handleChangeUsuario"></crm-filtros-negocio>
            </div>   -->

            <div class="w-100 mt-2 mb-2">
                <!-- <v-button label="Enviar um E-mail" icon="fa-envelope" :nb-btdef="true" @click="handleNovoEmail"></v-button> -->
                <v-button title="Sincronizar" icon="fa-refresh" :nb-btdef="false" @click="loadData"></v-button>
            </div>

            <div class="mt-3 card p-2" v-if="novoEmail">
                <crm-email :negocio="negociocrm" :pessoa="pessoa" @close="novoEmail = null"></crm-email>
            </div>

            <div class="default-container" v-if="!novoEmail">
                
                <tabs :tabs="tabs" :setActiveTab="activeTab" @onClickTab="changeTab"></tabs>

                <div v-if="emailList.length == 0" class="no-content mb-4">Nenhuma email foi encontrado</div>

                <div class="mainbox mt-2" v-for="(item, index) in emailList" :key="index">
                    <div class="row p-2 align-items-center" style="cursor: pointer" @click="showCodemail = item.codemail">
                        <div class="col-auto text-center">
                            <div class="list-icon">
                                <i v-if="item.inbox == 'S'" class="fa fa-arrow-down"></i>
                                <i v-else class="fa fa-arrow-right"></i>
                            </div>
                        </div>
                        <div class="col-md-6 col-6">
                            <span class="lbl-list">{{ item.data | formatDataHoraExtenso }}</span>
                            <span v-if="item.inbox == 'S' && item.from_list.length > 0" class="data-list w-100">{{ item.pessoa_nome }} {{ item.from_list[0].email }}</span>
                            <span v-if="item.inbox != 'S' && item.to_list.length > 0" class="data-list w-100">{{ item.to_list[0].nome }} {{ item.to_list[0].email }}</span>

                            <span v-if="item.visualizado=='S'" class="data-list w-100">{{ item.subject }}</span>
                            <span v-else class="data-list w-100"><strong> {{ item.subject }} </strong></span>
                                <a v-if="item.negocio_titulo" class="lbl-list pr-2" :href="'#/crm/negocio/'+item.link_codnegocio"><i class="fa fa-dollar pr-2" aria-hidden="true"></i> {{ item.negocio_titulo }}</a>
                                <a v-if="item.pessoa_nome" class="lbl-list pr-2" :href="'#/crm/pessoa/'+item.link_codnegocio"><i class="fa fa-user pr-2" aria-hidden="true"></i> {{ item.pessoa_nome }}</a>
                        </div>
                        <div class="col-md-auto col-3 text-right">
                            <span v-if="item.attachments.length > 1" class="lbl"><i class="fa fa-paperclip" aria-hidden="true" style="font-size: 18px"></i></span>
                        </div>
                    </div>
                </div>

            </div>

            <div class="nb-modal-scrollable" v-if="showCodemail">
                <div class="container nb-modal-scrollable-container" style="max-width: 90%">
                    <!-- <div class="nb-modal-header">
                    </div> -->
                    <div class="nb-modal-scrollable-body">
                        <crm-email :codemail="showCodemail" @closeform="closeEmail"></crm-email>
                    </div>
                </div>
            </div>

    </div>
</template>


<style>

</style>



// WEBPACK FOOTER //
// src/forms-crm/crm-email-list.vue